import {
  collection,
  onSnapshot,
  FirestoreError,
  query,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../types";
import { Child } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type ChildOnSnapshotCollectionService<T> = (
  userId: string,
  opts: ListServiceOpts,
  callback: (docs: Array<T>) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotCollection: ChildOnSnapshotCollectionService<
  EntityGet<Child>
> = (userId, opts: ListServiceOpts, callback, onError = () => {}) => {
  const collectionRef = collection(db, `/user/${userId}/child`);
  const { disableCache } = opts;
  const q = opts.listQueryFn
    ? opts.listQueryFn(collectionRef)
    : query(collectionRef);
  return onSnapshot(
    q,
    { includeMetadataChanges: disableCache },
    (querySnap) => {
      const { metadata } = querySnap;
      const { fromCache } = metadata;
      if (disableCache && fromCache) return;
      callback(
        querySnap.docs.map((doc) =>
          processTimestampFields(
            transformMetadata(
              {
                ...doc.data(),
                id: doc.id,
              } as EntityServerGet<Child>,
              doc.metadata
            )
          )
        )
      );
    },
    onError
  );
};

export default onSnapshotCollection;
